/**
 * Storefront and admin route policy for catalogofworks.
 * App.tsx will consume these lists in a follow-up slice; skeleton exports data only.
 */

/** /app/* segments disabled for this brand's public vitrine. */
export const disabledStorefrontPaths = [];

/** Tenant admin module keys skipped in router + TenantModuleGuard. */
export const disabledAdminModules = ['galleries', 'album_reviews', 'album_published_reviews', 'album_requests', 'album_books'];
